import { faXTwitter } from '@fortawesome/free-brands-svg-icons'
import {
  faBagsShopping,
  faCardsBlank,
  faCoins,
  faCrown,
  faGamepadModern,
  faHome,
  faMapLocationDot,
  faQuestionCircle,
  faScrollOld,
  faStore,
  faTicket,
  // faTreasureChest,
  faUserCog,
  faUserGroup,
  faWallet
} from '@fortawesome/pro-duotone-svg-icons'
import { Badge } from '@mui/material'

import {
  CASHBACK_URL,
  EXCHANGE_POINTS_URL,
  HOME_URL,
  INVITE_FRIENDS_URL,
  MEMBERSHIP_URL,
  MY_ITEMS_URL,
  PLAY_GAMES_URL,
  POST_TO_EARN_URL,
  QUESTS_URL,
  SCRATCH_CARDS_URL,
  // REWARD_BOXES_URL,
  SETTINGS_URL,
  SHOP_URL,
  STAKING_URL,
  TRANSACTIONS_URL
} from '../constants/navigation'

import brandConfig from 'brandConfig'
import customConfig from 'customConfig'
import { buildSleapUrl } from '../util/game.helpers'
import { maskWalletAddress } from '../util/wallet/wallet.helpers'

const { exchangeIcon, cashbackIcon, transactionsIcon } = customConfig

export const buildNavData = ({
  symbol,
  t,
  isQuestsEnabled,
  cashbackEarnOption,
  onWalletClick,
  connectedWallet,
  authId,
  onOpenCOEStore
}) => {
  return [
    createNavSection(t('navigation.welcome'), [
      buildHomeMenu(t),
      createNavItem(
        connectedWallet
          ? `${t('common.connected')}: ${maskWalletAddress(connectedWallet)} `
          : t('wallet.connect-wallet'),
        '',
        faWallet,
        false,
        onWalletClick,
        !connectedWallet && (
          <Badge
            color='error'
            overlap='circular'
            badgeContent=' '
            variant='dot'
            sx={{
              bottom: 12,
              '& .MuiBadge-badge': {
                height: 14,
                width: 14
              }
            }}
          ></Badge>
        )
      ),
      createNavItem(t('game.scratch-cards'), SCRATCH_CARDS_URL, faCardsBlank)
    ]),
    createNavSection(t('navigation.earn', { symbol }), [
      buildStakingMenu(t),
      buildPostToEarnMenu(t),
      ...buildQuestsMenu({ isQuestsEnabled, t }),
      createNavItem(t('games.play-games'), PLAY_GAMES_URL, faGamepadModern),
      // ...(features.rewardBoxes
      //   ? [
      //       createNavItem(
      //         t('reward-box.reward-boxes'),
      //         REWARD_BOXES_URL,
      //         faTreasureChest,
      //         false,
      //         null,
      //         <Label color='default'>{t('shop.soon')}</Label>,
      //         true
      //       )
      //     ]
      //   : []),
      ...buildCashbackMenu({ cashbackEarnOption, t }),
      createNavItem(
        t('games.travel-and-earn'),
        buildSleapUrl(authId),
        faMapLocationDot,
        true
      ),
      createNavItem(
        t('referral.invite-friends'),
        INVITE_FRIENDS_URL,
        faUserGroup
      )
    ]),
    createNavSection(t('navigation.spend', { symbol }), [
      buildShopMenu(t),
      buildExchangeMenu({ t, symbol }),
      ...buildVipStoreMenu({
        t,
        onOpenCOEStore
      }),
      createNavItem(
        t('navigation.events'),
        brandConfig.eventsUrl,
        faTicket,
        true
      )
    ]),
    createNavSection(
      t('user-account.my-account'),
      buildAccountMenu({ t, skipTransactions: true })
    )
  ]
}

const createNavSection = (subheader, items) => ({ subheader, items })
const createNavItem = (
  title,
  path,
  icon,
  external = false,
  onClickNav = null,
  info,
  disabled
) => ({
  title,
  path,
  icon,
  external,
  onClickNav,
  info,
  disabled
})
const buildPostToEarnMenu = (t) =>
  createNavItem(t('earn-via.post-to-earn'), POST_TO_EARN_URL, faXTwitter)

export const buildHomeMenu = (t) =>
  createNavItem(t('navigation.home'), HOME_URL, faHome)

const buildQuestsMenu = ({ t, isQuestsEnabled }) =>
  isQuestsEnabled
    ? [createNavItem(t('quest.quests'), QUESTS_URL, faScrollOld)]
    : []

const buildCashbackMenu = ({ t, cashbackEarnOption }) =>
  cashbackEarnOption
    ? [createNavItem(t('navigation.cashback'), CASHBACK_URL, cashbackIcon)]
    : []

const buildVipStoreMenu = ({ t, onOpenCOEStore }) =>
  brandConfig.features.enableCOEStorefront
    ? [
        createNavItem(
          t('navigation.vip-store'),
          '',
          faBagsShopping,
          false,
          onOpenCOEStore
        )
      ]
    : []

const buildShopMenu = (t) =>
  createNavItem(t('navigation.shop'), SHOP_URL, faStore)

const buildExchangeMenu = ({ t, symbol }) =>
  createNavItem(
    t('navigation.exchange', { symbol }),
    EXCHANGE_POINTS_URL,
    exchangeIcon
  )

export const buildAccountMenu = ({ t, skipTransactions }) => [
  createNavItem(t('navigation.membership'), MEMBERSHIP_URL, faCrown),
  createNavItem(t('shop.my-items'), MY_ITEMS_URL, customConfig.nftIcon),
  ...(!skipTransactions
    ? [
        createNavItem(
          t('navigation.transactions'),
          TRANSACTIONS_URL,
          transactionsIcon
        )
      ]
    : []),
  createNavItem(t('navigation.settings'), SETTINGS_URL, faUserCog),
  createNavItem(
    t('navigation.help-center'),
    brandConfig.helpCenterUrl,
    faQuestionCircle,
    true
  )
]

const buildStakingMenu = (t) =>
  createNavItem(t('navigation.staking'), STAKING_URL, faCoins, false)

export const buildHomeQuickMenu = ({ t, symbol, onOpenCOEStore }) => {
  return [
    buildPostToEarnMenu(t),
    buildStakingMenu(t),
    buildShopMenu(t),
    buildExchangeMenu({ t, symbol }),
    ...buildVipStoreMenu({
      t,
      onOpenCOEStore
    })
  ]
}
